module.exports = __webpack_public_path__ + "img/caetano-service-logo.5fc8e967.png";